(function () {
	"use strict";

	angular
		.module("qbePortal")
		.controller("QBTopBannerController", QBTopBannerController);

	QBTopBannerController.$inject = ["$scope", "labelService", "$window"];

	function QBTopBannerController($scope, labelService, $window) {
		var vm = this;

		vm.showTopBanner = false;
		//vm.bannerText = $window.qbe.fieldLabels.topBanner.bannerText;

		vm.closeTopBanner = function () {
			vm.showTopBanner = false;
		};

		$scope.$root.$on("show-top-banner", function (event, bannerText) {
			vm.bannerText = bannerText;
			vm.showTopBanner = true;
		});

		$scope.$root.$on("hide-top-banner", function () {
			vm.showTopBanner = false;
		});
	}

	angular.module("qbePortal").component("qbTopBanner", {
		templateUrl: "/ngviews/components/qbTopBanner.html",
		controller: QBTopBannerController,
		controllerAs: "vm",
		bindings: {},
	});
})();
